import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Menu from "@/components/Menu";
import Treats from "@/components/Treats";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import OrderForm from "@/components/OrderForm";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import TreatDetail from "@/components/TreatDetail";
import AdminPage from "@/components/admin/AdminPage";

function HomePage() {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                setTimeout(() => {
                    if (window.__lenis) {
                        window.__lenis.scrollTo(el, { offset: -80 });
                    } else {
                        el.scrollIntoView({ behavior: "smooth" });
                    }
                }, 80);
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [hash]);

    return (
        <>
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <About />
                <Menu />
                <Treats />
                <Gallery />
                <Testimonials />
                <OrderForm />
                <Faq />
                <Contact />
            </main>
        </>
    );
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App grain overflow-x-clip bg-[#FFFDF9] text-[#3D2318]" data-testid="app-root">
            <Toaster position="top-center" richColors />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/treats/:slug" element={<TreatDetail />} />
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}
